import styled from 'styled-components'

export const LabelText = styled.p`
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  margin: 0 0 10px 0;
  color: #495057;
`
